"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.realPromptToVideoTasksDbTable = exports.aiMediaFeaturesEnabled = exports.aiTextServicesGenerateScriptLambda = exports.viewmapBucket = exports.authoringEndpoint = exports.decisionTablesLoaderTable = exports.dtaasEndPoint = exports.resolverEndPoint = exports.avatarServiceEndpoint = exports.narrationServiceEndpoint = exports.resourceTrackingDeliverySystemName = exports.hobbitEndpoint = exports.mockNarrationServerEndpoint = exports.narrationServerEndpoint = exports.gaTrackingId = exports.designerSyncS3RoleArn = exports.designerSyncRootPath = exports.sharedAnimationRootPath = exports.designerLogsBucket = exports.sharedAnimationBucket = exports.tableauBaseURL = exports.tableauWorkbookName = exports.tableauOnlineDomain = exports.tableauOnlineSiteId = exports.tableauOnlineSiteName = exports.tableauOnlineAdminUser = exports.sisenseUser = exports.sisenseDomain = exports.accountsServerEndPoint = exports.reportServerEndpoint = exports.projectNamePattern = exports.assetsPerPage = exports.renderer3EndPoint = exports.prodUrl = exports.generateRaasApiKeyEndpoint = exports.mediaCropHintsLambda = exports.mediaAssetEditVideoLambda = exports.mediaAssetTrimVideoLambda = exports.assetsRootPath = exports.assetsBucketCloudFront = exports.feedFilesBucket = exports.exportAccountDataBucket = exports.assetsBucket = exports.version = exports.envName = exports.appName = exports.port = exports.env = exports.Environments = exports.reportConfigurationTemplate = void 0;
exports.AI_TEXT_SERVICES = exports.authServices = exports.auth0APIClientId = exports.auth0Domain = exports.corpOktaTableauGroupId = exports.corpOktaStudioGroupId = exports.corpOktaEndpoint = exports.oktaTableauGroupId = exports.oktaSundayskyCorpGroupId = exports.oktaStudioGroupId = exports.oktaEndpoint = exports.GOOGLE_CLIENT_ID = exports.virusScanLambda = exports.cxSystemDataElementsArr = exports.systemDataElementsArr = exports.adsSystemDataElementsArr = exports.systemDataElements = exports.recordingStatuses = exports.assetStatuses = exports.assetTypes = exports.dataElementOrigins = exports.dataElementTypes = exports.realPromptToVideoUsersDbTable = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.reportConfigurationTemplate = {}; //require("./reportConfigurationTemplate.json");
var Environments;
(function (Environments) {
    Environments["dev"] = "dev";
    Environments["prod"] = "production";
    Environments["test"] = "test";
    Environments["stg"] = "staging";
})(Environments || (exports.Environments = Environments = {}));
const getAssetBucket = (env) => {
    switch (env) {
        case Environments.prod:
            return "sundaysky-smartvideo-hub-assets";
        case Environments.stg:
            return "hub-dev-assets-staging";
        case Environments.test:
            return "hub-dev-assets-test"; // Not a real bucket, simply for testing
        case Environments.dev:
        default:
            return "hub-dev-assets-dev";
    }
};
const getAssetCloudfront = (env) => {
    switch (env) {
        case Environments.prod:
            return "smartvideo-hub-assets.sundaysky.com";
        case Environments.stg:
            return "smartvideo-hub-assets-staging.sundaysky.com";
        case Environments.test:
            return "smartvideo-hub-assets-test.sundaysky.com";
        case Environments.dev:
        default:
            return "smartvideo-hub-assets-dev.sundaysky.com";
    }
};
const withSuffixSlash = (str) => {
    return (str && !str.endsWith("/")) ? `${str}/` : str;
};
const generateSystemValueSet = (list) => {
    return list.map(value => {
        return {
            id: "_system_" + value,
            dn: value
        };
    });
};
const getVirusScanLambda = (env) => {
    switch (env) {
        case Environments.prod:
            return "hub-antivirus-scan-prod";
        case Environments.stg:
        case Environments.dev:
            return "hub-antivirus-scan-dev";
        default:
            return null; // change to hub-antivirus-scan-dev to test it locally
    }
};
exports.env = process.env.NODE_ENV;
exports.port = Number(process.env.HUB_PORT) || 8080;
exports.appName = "hub-poc";
exports.envName = "hub-poc-dev";
exports.version = 0;
exports.assetsBucket = process.env.HUB_ASSET_BUCKET || getAssetBucket(exports.env);
exports.exportAccountDataBucket = process.env.EXPORT_ACCOUNT_DATA_BUCKET;
exports.feedFilesBucket = (_a = process.env.FEED_FILES_BUCKET) !== null && _a !== void 0 ? _a : "platform-feed-files-dev";
exports.assetsBucketCloudFront = process.env.HUB_ASSETS_CLOUDFRONT || getAssetCloudfront(exports.env);
exports.assetsRootPath = withSuffixSlash(process.env.HUB_ASSET_ROOT_PATH) || "";
exports.mediaAssetTrimVideoLambda = process.env.MEDIA_ASSET_TRIM_VIDEO || "";
exports.mediaAssetEditVideoLambda = process.env.MEDIA_ASSET_EDIT_VIDEO || "";
exports.mediaCropHintsLambda = process.env.MEDIA_CROP_HINTS || "";
exports.generateRaasApiKeyEndpoint = process.env.GENERATE_RAAS_API_KEY_ENDPOINT || "";
exports.prodUrl = process.env.RAAS_END_POINT || "https://api.sundaysky.com/video/prod";
exports.renderer3EndPoint = process.env.RENDERER3_END_POINT || "https://apis.sundaysky.com/video/prod-013";
exports.assetsPerPage = 200;
exports.projectNamePattern = "^[\\w-]+$";
exports.reportServerEndpoint = process.env.REPORT_SERVER_ENDPOINT || "";
exports.accountsServerEndPoint = withSuffixSlash(process.env.ACCOUNTS_SERVER_ENDPOINT);
exports.sisenseDomain = process.env.SISENSE_DOMAIN;
exports.sisenseUser = process.env.SISENSE_USER;
exports.tableauOnlineAdminUser = process.env.TABLEAU_ONLINE_ADMIN_USER;
exports.tableauOnlineSiteName = process.env.TABLEAU_ONLINE_SITE_NAME;
exports.tableauOnlineSiteId = process.env.TABLEAU_ONLINE_SITE_ID;
exports.tableauOnlineDomain = process.env.TABLEAU_ONLINE_DOMAIN;
exports.tableauWorkbookName = process.env.TABLEAU_WORKBOOK_NAME;
exports.tableauBaseURL = `${exports.tableauOnlineDomain}/t/${exports.tableauOnlineSiteName}`;
exports.sharedAnimationBucket = process.env.HUB_ANIMATION_BUCKET || (exports.env === Environments.prod ? "sundaysky-authoring-repository" : "hub-shared-animation-staging");
exports.designerLogsBucket = process.env.DESIGNER_LOGS_BUCKET || (exports.env === Environments.prod ? "sundaysky-raas-logs" : "sundaysky-raas-logs-dev");
exports.sharedAnimationRootPath = (exports.env === Environments.prod) ? "animations/" : "resources/";
exports.designerSyncRootPath = "ae-synced-assets/";
exports.designerSyncS3RoleArn = (exports.env === Environments.prod) ? "arn:aws:iam::383543149372:role/designer-sync-role" : "arn:aws:iam::651241207884:role/designer-sync-role";
exports.gaTrackingId = process.env.HUB_GA_TRACKING_ID;
exports.narrationServerEndpoint = process.env.HUB_NARRATION_SERVER_ENDPOINT || "https://narration.sundaysky.com/narration-server/api/";
exports.mockNarrationServerEndpoint = process.env.HUB_MOCK_NARRATION_SERVER_ENDPOINT || exports.narrationServerEndpoint;
exports.hobbitEndpoint = process.env.HOBBIT_ENDPOINT || "";
exports.resourceTrackingDeliverySystemName = process.env.RESOURCE_TRACKING_DELIVERY_SYSTEM_NAME || "";
exports.narrationServiceEndpoint = process.env.HUB_NARRATION_SERVICE_ENDPOINT || "";
exports.avatarServiceEndpoint = process.env.HUB_AVATAR_SERVICE_ENDPOINT || "";
exports.resolverEndPoint = process.env.HUB_RESOLVER_ENDPOINT || "https://api-alpha.sundaysky.com/resolver/";
exports.dtaasEndPoint = process.env.HUB_DTAAS_ENDPOINT || "";
exports.decisionTablesLoaderTable = process.env.HUB_DECISIONTABLE_LOADER_TABLE || "";
exports.authoringEndpoint = process.env.HUB_AUTHORING_ENDPOINT || "https://auth-qa.sundaysky.com";
exports.viewmapBucket = process.env.HUB_VIEWMAP_BUCKET;
exports.aiTextServicesGenerateScriptLambda = process.env.AI_TEXT_SERVICES_GENERATE_SCRIPT || "";
exports.aiMediaFeaturesEnabled = process.env.AI_MEDIA_FEATURES_ENABLED === "true";
exports.realPromptToVideoTasksDbTable = process.env.REAL_PROMPT_TO_VIDEO_TASKS_TABLE;
exports.realPromptToVideoUsersDbTable = process.env.REAL_PROMPT_TO_VIDEO_USERS_TABLE;
exports.dataElementTypes = {
    string: "string",
    number: "number",
    boolean: "boolean",
    dateTime: "datetime",
    url: "url"
};
exports.dataElementOrigins = {
    feed: "feed",
    derived: "derived",
    system: "system"
};
exports.assetTypes = {
    decisionTable: "decision_table",
    mappingTable: "mapping_table",
    animation: "animation",
    narrator: "narrator",
    curated: "curated",
    recording: "recording",
    story: "story",
    scene: "scene",
    program: "program"
};
exports.assetStatuses = {
    notReady: "notReady",
    ready: "ready",
    request: "request",
    approved: "approved"
};
exports.recordingStatuses = {
    approved: "approved",
    rejected: "rejected",
    pendingApproval: "pendingApproval"
};
exports.systemDataElements = {
    Now: {
        type: exports.dataElementTypes.dateTime,
        description: "The date and time in which the video is being viewed (Time zone is EST unless sent in “sys:TimeZone”)",
        origin: exports.dataElementOrigins.system
    },
    Duration: {
        type: exports.dataElementTypes.number,
        description: "The video ad duration",
        origin: exports.dataElementOrigins.system
    },
    TimeZone: {
        type: exports.dataElementTypes.string,
        description: "Sets the time zone to any Date-Time data element that doesn’t explicitly includes the time zone.",
        origin: exports.dataElementOrigins.system
    },
    UserDevice: {
        Type: {
            type: exports.dataElementTypes.string,
            description: "Requires forwarding the user agent header.",
            origin: exports.dataElementOrigins.system
        },
        MobileOS: {
            type: exports.dataElementTypes.string,
            description: "Requires forwarding the user agent header.",
            origin: exports.dataElementOrigins.system
        }
    }
};
exports.adsSystemDataElementsArr = [
    {
        id: "HubSystem:Duration",
        displayName: "duration",
        type: exports.dataElementTypes.number,
        description: "Duration",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet(["15", "30", "45", "60"])
    },
    {
        id: "HubSystem:Zip",
        displayName: "zip",
        type: exports.dataElementTypes.string,
        description: "The zip code of the location from which the user is viewing the ad",
        origin: exports.dataElementOrigins.system
    },
    {
        id: "HubSystem:State",
        displayName: "state",
        type: exports.dataElementTypes.string,
        description: "The state or province (U.S. or Canada) from which the user is viewing the ad",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet([
            "AB",
            "AK",
            "AL",
            "AR",
            "AZ",
            "BC",
            "CA",
            "CO",
            "CT",
            "DC",
            "DE",
            "DF",
            "FL",
            "GA",
            "HI",
            "IA",
            "ID",
            "IL",
            "IN",
            "KS",
            "KY",
            "LA",
            "MA",
            "MB",
            "MD",
            "ME",
            "MI",
            "MN",
            "MO",
            "MS",
            "MT",
            "NB",
            "NC",
            "ND",
            "NE",
            "NH",
            "NJ",
            "NL",
            "NM",
            "NS",
            "NT",
            "NU",
            "NV",
            "NY",
            "OH",
            "OK",
            "ON",
            "OR",
            "PA",
            "PE",
            "QC",
            "RI",
            "SC",
            "SD",
            "SK",
            "TN",
            "TX",
            "UT",
            "VA",
            "VT",
            "WA",
            "WI",
            "WV",
            "WY",
            "YT"
        ])
    },
    {
        id: "HubSystem:Topic",
        displayName: "topic",
        type: exports.dataElementTypes.string,
        description: "The topic of the page where the ad is being displayed",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet([
            "Arts & Entertainment",
            "Autos & Vehicles",
            "Beauty & Fitness",
            "Books & Literature",
            "Business & Industrial",
            "Computers & Electronics",
            "Finance",
            "Food & Drink",
            "Games",
            "Health",
            "Hobbies & Leisure",
            "Home & Garden",
            "Internet & Telecom",
            "Jobs & Education",
            "Law & Government",
            "News",
            "Online Communities",
            "People & Society",
            "Pets & Animals",
            "Real Estate",
            "Reference",
            "Science",
            "Shopping",
            "Sports",
            "Travel",
            "World Localities"
        ])
    },
    {
        id: "HubSystem:Experiment",
        displayName: "experiment",
        type: exports.dataElementTypes.string,
        description: "The list of experiment groups to which the user belongs (use with operator “contains”)",
        origin: exports.dataElementOrigins.system
    },
    {
        id: "HubSystem:videoAspectRatio",
        displayName: "videoAspectRatio",
        type: exports.dataElementTypes.string,
        description: "The aspect ratio of the video (i.e., Full landscape (16:9), Full portrait (9:16), Square (1:1))",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet(["16:9", "9:16", "1:1"])
    },
    {
        id: "HubSystem:videoQualityProfile",
        displayName: "videoQualityProfile",
        type: exports.dataElementTypes.string,
        description: "The quality profile of the video (e.g., SD (default), HD-Ready, etc.)",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet(["sd", "sd-intermediate", "sd-high", "hd-ready", "hd-ready-intermediate", "hd-ready-high", "hd"])
    }
];
exports.systemDataElementsArr = [
    {
        id: "HubSystem:now",
        name: "Now",
        displayName: "Now",
        type: exports.dataElementTypes.dateTime,
        description: "The date and time in which the video is being viewed (Time zone is EST unless sent in “sys:TimeZone”)",
        origin: exports.dataElementOrigins.system
    },
    {
        id: "HubSystem:TimeZone",
        name: "TimeZone",
        displayName: "TimeZone",
        type: exports.dataElementTypes.string,
        description: "The default time zone of dates without an explicit time zone",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet(moment_timezone_1.default.tz.names())
    },
    {
        id: "HubSystem:UserDevice.Type",
        name: "UserDevice.Type",
        displayName: "UserDevice.Type",
        type: exports.dataElementTypes.string,
        description: "The user’s device type (i.e., Desktop, Mobile, Tablet)",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet(["Desktop", "Mobile", "Tablet"])
    },
    {
        id: "HubSystem:UserDevice.MobileOS",
        name: "UserDevice.MobileOS",
        displayName: "UserDevice.MobileOS",
        type: exports.dataElementTypes.string,
        description: "The user’s mobile operating system (i.e., Android, iOS, Other)",
        origin: exports.dataElementOrigins.system,
        valueSet: generateSystemValueSet(["Android", "iOS", "Other"])
    },
    {
        id: "HubSystem:Story",
        name: "Story",
        type: exports.dataElementTypes.string,
        description: "The story selected in the video being viewed",
        origin: exports.dataElementOrigins.system,
        valueSet: []
    }
];
exports.cxSystemDataElementsArr = [
    {
        id: "HubSystem:UserID",
        name: "UserID",
        displayName: "User ID",
        type: exports.dataElementTypes.string,
        description: "The ID of the user, used for reporting",
        origin: exports.dataElementOrigins.system,
        valueSet: []
    }
];
exports.virusScanLambda = getVirusScanLambda(exports.env);
// Google
exports.GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID || "";
// Okta Studio account
exports.oktaEndpoint = process.env.OKTA_ENDPOINT || "";
exports.oktaStudioGroupId = process.env.OKTA_STUDIO_GROUP_ID || "";
exports.oktaSundayskyCorpGroupId = process.env.OKTA_SUNDAYSKY_CORP_USERS_GROUP_ID || "";
exports.oktaTableauGroupId = process.env.OKTA_TABLEAU_GROUP_ID || "";
// Okta Corporate account
exports.corpOktaEndpoint = process.env.CORP_OKTA_ENDPOINT || "";
exports.corpOktaStudioGroupId = process.env.CORP_OKTA_STUDIO_GROUP_ID || "";
exports.corpOktaTableauGroupId = process.env.CORP_OKTA_TABLEAU_GROUP_ID || "";
// Auth0 account
exports.auth0Domain = process.env.AUTH0_DOMAIN || "";
exports.auth0APIClientId = process.env.AUTH0_API_CLIENT_ID || "";
// External Config file
const configFilePath = process.env.HUB_CONFIG_PATH;
const externalConfig = configFilePath ? require(`${configFilePath}`) : require("./hub.conf.json");
exports.authServices = externalConfig.authServices;
//AI SERVICES
exports.AI_TEXT_SERVICES = process.env.AI_TEXT_SERVICES_API;
// todo - remove this
const TESTING_JENKINS = 10;
//# sourceMappingURL=config.js.map